<template>
  <span class="tag-badge" :class="`tag-badge--${variant}`">{{ label }}</span>
</template>

<script>
/**
 * TagBadge
 *
 * Pill simples com um texto — usado para colunas do tipo "lista de
 * marcadores" (ex.: ciclos, categorias). Genérico: não conhece o
 * domínio de quem o usa, só recebe o texto e a cor.
 */
export default {
  name: "TagBadge",

  props: {
    /** Texto exibido dentro do badge. */
    label: {
      type: String,
      required: true,
    },
    /** Cor de fundo do badge, mapeada para as variáveis do projeto. */
    variant: {
      type: String,
      default: "blue",
      validator: (value) =>
        ["blue", "purple", "yellow", "green", "orange"].includes(value),
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.tag-badge {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 6px;
  color: $white;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  margin: 2px 6px 2px 0;
}

.tag-badge--blue {
  background: $blue;
}

.tag-badge--purple {
  background: $purple;
}

.tag-badge--yellow {
  background: $yellow;
  color: $grey1;
}

.tag-badge--green {
  background: $green1;
}

.tag-badge--orange {
  background: $orange;
}
</style>
